var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame"},[(!_vm.loaded)?_c('div'):_vm._e(),_vm._v(" "),_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],staticStyle:{"width":"100%","height":"100%"},attrs:{"src":this.$store.state.about_url},on:{"load":_vm.onload}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0127f4c6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = null
// module chunks = 